import bhuri from "./bhuri.jpeg";
import farhat from "./farhat.jpeg";
import geeta from "./geetaDevi.jpeg";
import kamna from "./kamnaSharma.jpeg";
import preveen from "./preveen.jpeg";
import sushma from "./sushma.jpeg";

export const customersTestemonials = [
  {
    author: "Bhuri",
    image: bhuri,
    text: "This product changed my life! Highly recommend it to everyone!",
  },
  {
    author: "Farhat",
    image: farhat,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Geeta Devi",
    image: geeta,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Kamna Sharma",
    image: kamna,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Preveen",
    image: preveen,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Sushma",
    image: sushma,
    text: "Amazing service and fantastic quality!",
  },
];

export const customersTestemonials2 = [
  {
    author: "Bhuri",
    image: bhuri,
    text: "This product changed my life! Highly recommend it to everyone!",
  },
  {
    author: "Farhat",
    image: farhat,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Geeta Devi",
    image: geeta,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Kamna Sharma",
    image: kamna,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Preveen",
    image: preveen,
    text: "Amazing service and fantastic quality!",
  },
  {
    author: "Sushma",
    image: sushma,
    text: "Amazing service and fantastic quality!",
  },
];
